(function (window) {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var toggles = document.querySelectorAll(".hamburger"),
      overlay = document.querySelector(".bot-menu-overlay"),
      menuEl = document.querySelector(".bot-menu");

    toggles.forEach(function (toggle) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        toggles.forEach(function (t) {
          t.classList.toggle("is-active");
        });
        document.body.classList.toggle("bot-menu-open");

        // On open, try to open submenu path
        if (window.menu) {
          const pathSegments = window.location.pathname
            .split("/")
            .filter(Boolean);
          const last = pathSegments[pathSegments.length - 1];
        }
      });
    })

    if (overlay) {
      overlay.addEventListener("click", function () {
        document.body.classList.remove("bot-menu-open");
        toggles.forEach(function (t) {
          t.classList.remove("is-active");
        });
      });
    }

    if (menuEl && window.MLMenu) {
      window.menu = new MLMenu(menuEl, {
        breadcrumbsCtrl: true,
        backCtrl: true,
        initialBreadcrumb: "All",
      });
    }
  });
})(window);
